import React from "react";
import { Link } from "react-router-dom";

import Joi from "joi-browser";
import Form from "../../components/common/form";
import withMyHook from "../../components/common/withMyHook";
import NavbarGroup from "../../components/navbarGroup";

// Services
import httpService from "./../../services/httpService.js";
import config from "../../config.json";

// Utilities
import { ToastContainer, Zoom, toast } from "react-toastify";
//Other
import { ArrowLeftCircle } from "react-bootstrap-icons";

class entityRaceAllocationForm extends Form {
  state = {
    data: {
      entityID: "",
    },
    entites: [],
    errors: {},
    groupID: "",
    raceID: "",
    raceNameYear: "",

    myParams: this.props.myParams,
    myNavigate: this.props.myNavigate,
  };

  schema = {
    entityID: Joi.string().label("Entity"),
  };

  async componentDidMount() {
    const ID = this.state.myParams.id;
    const raceID = localStorage.getItem("raceID");
    const groupID = localStorage.getItem("groupID");
    const raceNameYear = localStorage.getItem("raceNameYear");

    // Set the State
    this.setState({ groupID, raceID, raceNameYear });

    // Load the Select boxes with the data.

    // Fill the drop down list based on if its a new entry ie not already allocated
    // or load the fill list so the user can select an exiting one
    if (ID === "new") {
      // Get entites by Group ID
      let { data: Dbdata } = await httpService.get(
        config.apiEndpointUnalloctedEntitesGet + "?groupID=" + groupID
      );
      this.setState({ entites: Dbdata });
    } else {
      // Get entites by Group ID
      let { data: Dbdata } = await httpService.get(
        config.apiEndpointEntitesGet + "?groupID=" + groupID
      );
      this.setState({ entites: Dbdata });
    }

    // Get data from database to display options in textfields
    if (ID === "new") return;
    let { data: retreivedData } = await httpService.get(
      config.apiEndpointEntityRaceAllocGet +
        "?id=" +
        ID +
        "&" +
        "raceID=" +
        raceID
    );

    if (!retreivedData) return this.state.myNavigate("/not-found");
    this.setState({ data: this.mapToViewModel(retreivedData) });
  }

  doSubmit = async () => {
    // Get the group Id for a new entry
    const ID = this.state.myParams.id;

    if (ID === "new") {
      // add a new entry
      let dataToSend = this.state.data;
      let formData = new FormData();

      // add the group ID to the form data
      formData.append("groupID", this.state.groupID);
      formData.append("raceID", this.state.raceID);

      Object.keys(dataToSend).forEach((key) => {
        formData.append(key, dataToSend[key]);
      });

      try {
        await httpService.post(config.apiEndpointEntityRaceAllocAdd, formData);
      } catch (error) {
        if (error.reponse && error.reponse.status === 404)
          toast.error("Something failed while adding.");
      }
    } else {
      // Update an entry
      let dataToSend = this.state.data;
      let formData = new FormData();

      //add the Id to the data to send to db
      formData.append("id", ID);
      formData.append("raceID", this.state.raceID);
      //loop through the data and add to from data
      Object.keys(dataToSend).forEach((key) => {
        formData.append(key, dataToSend[key]);
      });

      try {
        await httpService.post(
          config.apiEndpointEntityRaceAllocUpdate,
          formData
        );
      } catch (error) {
        if (error.reponse && error.reponse.status === 404)
          toast.error("Something failed while updating.");
      }
    }

    this.state.myNavigate(`/pageEntityRaceAlloc/${this.state.raceID}`);
  };

  //Submit a delete Group
  doDelete = async () => {
    const ID = this.state.myParams.id;
    try {
      const deleteReply = await httpService.get(
        config.apiEndpointEntityRaceAllocDelete + "?id=" + ID
      );

      var myObject = JSON.parse(deleteReply);
    } catch (error) {
      if (error.reponse && error.reponse.status === 404)
        toast.error("Something failed while deleting.");
    }

    this.state.myNavigate(`/pageEntityRaceAlloc/${this.state.raceID}`);
  };

  mapToViewModel(data) {
    return {
      entityID: data.entityID,
    };
  }

  render() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    return (
      <React.Fragment>
        <ToastContainer
          draggable={true}
          transition={Zoom}
          autoClose={2000}
          position="top-center"
        />
        <NavbarGroup />
        <div className="container container-top-70">
          <div className="row">
            <div className="form-container">
              <form onSubmit={this.handleSubmit} id="formID">
                <table className="table table-group">
                  <thead>
                    <tr>
                      <th>
                        <Link
                          to={`/pageEntityRaceAlloc/${this.state.raceID}`}
                          className="btn p-0"
                        >
                          <ArrowLeftCircle color="#002072" size={40} />
                        </Link>
                      </th>
                      <th>
                        <h4>{this.state.raceNameYear}</h4>
                      </th>
                    </tr>
                    <tr align="center">
                      <th colSpan={2}>
                        <h6>Entity Allocation</h6>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Entities</td>
                      <td>
                        {this.state.entites &&
                          this.renderSelect(
                            "entityID",
                            "entityName",
                            this.state.entites,
                            ""
                          )}
                      </td>
                    </tr>

                    <tr align="center">
                      <td colSpan={2}>
                        <span className="button-padding">
                          {this.renderSaveButton("Save")}
                        </span>
                        <span className="button-padding">
                          {this.renderButtonDelete("Delete")}
                        </span>
                        <span className="button-padding">
                          {this.renderButtonClear("Clear")}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </form>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withMyHook(entityRaceAllocationForm);
